// Rothko Colour Palettes adapted from https://github.com/mmerrittsmith/rothko
const rothko_palettes = [
  {
    pal_num: 0,
    title: "Violet, Black, Orange, Yellow on White and Red2",
    palette: ["#B41840", "#F0C73C", "#F1DBC7", "#E48504", "#372412"],
  },
  {
    pal_num: 3,
    title: "Untitled 1949",
    palette: ["#414030", "#9EA683", "#EAB23B", "#F3C855", "#DABF7B", "#F0D69A"],
  },
  {
    pal_num: 4,
    title: "Number 5",
    palette: ["#DD2B18", "#F86602", "#FBA901", "#F9C007"],
  },
  {
    pal_num: 6,
    title: "Blue, Green, and Brown",
    palette: ["#231526", "#2A1D26", "#262F5B", "#3C529D", "#5B73C9", "#738BE0"],
  },
  {
    pal_num: 7,
    title: "Number 10",
    palette: ["#4E5F71", "#7A9482", "#9EC0A7", "#C2C27F", "#C9A203", "#BE810D"],
  },
  {
    pal_num: 9,
    title: "Untitled 1953",
    palette: ["#2D313B", "#AD6068", "#CC5177", "#D15C8D"],
  },
  {
    pal_num: 12,
    title: "Green and Tangerine on Red",
    palette: ["#E74607", "#383A39", "#C49261", "#CE6636"],
  },
  {
    pal_num: 13,
    title: "Light Red Over Black",
    palette: ["#FB3D1E", "#CF3C23", "#A4422C", "#56372D"],
  },
  {
    pal_num: 14,
    title: "Number 14",
    palette: ["#F96311", "#CE3803", "#A33003", "#201128", "#000000"],
  },
  {
    pal_num: 15,
    title: "Orange, Red, Yellow",
    palette: ["#E7602E", "#D55D2D", "#A84838", "#842B2A"],
  },
  {
    pal_num: 17,
    title: "Untitled 1969",
    palette: ["#000000", "#3C3029", "#8D847D", "#D8CEC8", "#E7DDD5"],
  },
];

export { rothko_palettes };
